export const ACCOUNT_NUMBER = "Account number";
export const ACCOUNT_SUMMARY = "Account summary";
export const ACCOUNT_VALUE = "Account value";
export const ADJUSTMENTS = "Adjustments";
export const ASSET_NAME = "Asset name";
export const CLIENT_REFERENCE = "Client reference";
export const GAIN_LOSS = "Gain / loss";
export const INTER_ACCT_TRANSFER_IN = "Inter-account transfer in";
export const INTER_ACCT_TRANSFER_OUT = "Inter-account transfer out";
export const INVESTMENTS = "Investments";
export const ISIN = "ISIN";
export const JOINT_OWNER = "Joint owner";
export const LAST_PRICE = "Last price";
export const MONEY_IN = "Money in";
export const MONEY_OUT = "Money out";
export const NAME = "Name";
export const PERCENTAGE_VALUE = "% of value";
export const PORTFOLIO_SUMMARY = "Portfolio summary";
export const PORTFOLIO_VALUE = "Portfolio value";
export const QUANTITY = "Quantity";
export const VALUATION_AS_AT = "Valuation as at";
export const VALUE = "Value";
export const WRAPPER_TYPE = "Wrapper type";
